import React, { useEffect, useState } from "react";

const MobileSelector = ({ options, handleSelectedState, preSelected }) => {
  const [finalSelectedOptions, setFinalSelectedOptions] = useState([]);
  // const [menuIsOpen, setMenuIsOpen] = useState(false);

  useEffect(() => {
    if (preSelected.length > 0) {
      setFinalSelectedOptions(
        options.filter((option) => preSelected.includes(option.value))
      );
    } else {
      setFinalSelectedOptions(options);
    }
  }, []);

  const handleChange = (event) => {
    const selectedOptions = Array.from(
      event.target.selectedOptions,
      (option) => option.value
    );

    setFinalSelectedOptions(
      options.filter((option) => selectedOptions.includes(option.value))
    );
    handleSelectedState(selectedOptions);
  };

  return (
    <div className="form-group w-100">
      <label htmlFor="mobile-selector w-100">Select Options</label>
      <select
        id="mobile-selector"
        className="form-control w-100 w-md-auto"
        multiple
        value={finalSelectedOptions.map((option) => option.value)}
        onChange={handleChange}
        onFocus={() => {}}
        onBlur={() => {}}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default MobileSelector;
